import DiscographyPage from './DiscographyPage';
import MainPage from './MainPage/MainPage';
import AlbumPage from './AlbumPage';
import SongPage from './SongPage';

const pages = { MainPage, DiscographyPage, AlbumPage, SongPage };

export default pages;
